import {HttpClient} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {CSubscription} from '../models';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  readonly #http: HttpClient = inject(HttpClient);
  readonly #url: string = S2WX_API_URL;

  subscribe(subscription : CSubscription): Observable<any> {
    return this.#http.put(`${this.#url}/Notifications`, subscription);
  }
  unsubscribe(subscription : CSubscription): Observable<any>{
    return this.#http.delete(`${this.#url}/Notifications`, {
      body: subscription
    });
  }
}
